import { ZopAuthLibConfig } from '@zopup/zop-auth';
import { environment } from '../../environment/environment';

export const MAIN_APP_AUTH_CONFIG: ZopAuthLibConfig = {
  signinRedirectionUrl: '/tenant-selection',
  routes: {
    signIn: '/sign-in',
    signOut: '/sign-out',
    tenantSelection: '/tenant-selection',
    tenantCreate: '/tenant-create',
    packageSelection: '/package-selection',
    companyCreate: '/company-create',
    branchSelection: '/branch-selection',
  },
  api: {
    baseUrl: environment.api.baseUrl,
    endpoints: environment.api.endpoints
  },
  keycloak: {
    silentCheckSsoPath: '/silent-check-sso.html'
  },
  features: {
    enableTenantSelection: true,
    enablePackageSelection: true,
    enableCompanyCreation: true,
    enableBranchSelection: true,
  },
  fallbackUrls: {
    defaultRedirect: '/tenant-selection',
    authFailure: '/sign-in',
    sessionExpired: '/sign-in',
  }
};
